export { prismicRichTextContentSerializer } from '@monofront/business/utils/prismicRichTextContentSerializer';
export { usePrismicContentSerializer } from './usePrismicContentSerializer';
